export default {
  "9142C": [
    {
      from_internal: "empBusinessName",
      to: "b1_emp_name",
    },
    {
      from_internal: "empTradeName",
      to: "b2_emp_dba",
    },
    {
      from_internal: "empAddr1",
      to: "b3_emp_address_1",
    },
    {
      from_internal: "empAddr2",
      to: "b4_emp_address_2",
    },
    {
      from_internal: "empCity",
      to: "b5_emp_city",
    },
    {
      from_internal: "empState",
      to: "b6_emp_state_id",
      type: "state",
    },
    {
      from_internal: "empPostcode",
      to: "b7_emp_zip",
    },
    {
      from_internal: "empCountry",
      to: "b8_emp_country_id",
    },
    {
      from_internal: "empProvince",
      to: "b9_emp_province",
    },
    {
      from_internal: "empPhone",
      to: "b10_emp_phone",
    },
    {
      from_internal: "empPhoneext",
      to: "b11_emp_phone_ext",
    },
    {
      from_internal: "empFein",
      to: "b12_emp_fein",
    },
    {
      from_internal: "empNaics",
      to: "b13_emp_naics",
      type: "string",
    },
    {
      from_internal: "empNaicsDesc",
      to: "b13_emp_naics_description",
      type: "string",
    },
    {
      from_internal: "suggestedSocCode",
      _9141_alternative_id: "pwdLinkingSocCode",
      _9141_alternative_id_v2: "pwdOnetCode",
      to: "ea1_soc_code",
      type: "string",
    },
    {
      from_internal: "suggestedSocTitle",
      _9141_alternative_id: "pwdSocTitle",
      _9141_alternative_id_v2: "pwdOnetTitle",
      to: "ea2_soc_title",
      type: "string",
    },
    {
      from_internal: "otherWorksiteLocation",
      to: "ec9_is_multiple_locations",
      type: "bool",
    },
    {
      from_internal: "caseNumber",
      to: "ea3_pwd_number",
    },
    {
      from_internal: "jobTitle",
      to: "eb1_job_title",
    },
    {
      from_internal: "jobDuties",
      to: "eb5_job_duties",
    },
    {
      from_internal: "primaryEducationLevel",
      to: "eb8_education_id",
    },
    {
      from_internal: "specialRequirements",
      to: "eb12_special_requirements",
    },
    {
      from_internal: "numberOfMonthsTraining",
      to: "eb9_training_months",
      type: "number",
    },
    {
      from_internal: "superviseOtherEmp",
      to: "eb11_is_supervision",
      type: "bool",
    },
    {
      from_internal: "superviseHowMany",
      to: "eb11a_number_supervised",
      type: "number",
    },
    {
      from_internal: "empExperienceMonths",
      to: "eb10_experience_months",
      type: "number",
    },
    {
      from_internal: "primaryWorksiteAddr1",
      to: "ec1_work_address_1",
    },
    {
      from_internal: "primaryWorksiteAddr2",
      to: "ec2_work_address_2",
    },
    {
      from_internal: "primaryWorksiteCity",
      to: "ec3_work_city",
    },
    {
      from_internal: "primaryWorksiteState",
      to: "ec4_work_state_id",
      type: "state",
    },
    {
      from_internal: "primaryWorksitePostalCode",
      to: "ec5_work_zip",
    },
    {
      from_internal: "otherWorksites",
      to: "appx_b_locations",
    },
    {
      from_internal: null, // not recieving the "per" field from Appian
      to: "ec7_pay_rate_id",
    },
  ],
  "9142B": [
    {
      from_internal: "_blsCounties",
      to: "_blsCounties",
      type: "string",
    },
    {
      from_internal: "suggestedSocCode",
      _9141_alternative_id: "pwdOnetCode",
      to: "tempneedSoc",
      type: "string",
    },
    {
      from_internal: "suggestedSocTitle",
      _9141_alternative_id: "pwdOnetTitle",
      to: "tempneedSocTitle",
      type: "string",
    },
    {
      from_internal: "jobTitle",
      to: "tempneedJobtitle",
    },
    {
      from_internal: "dateSubmitted",
      to: "pwdDateSubmitted",
      type: "number",
    },
    {
      from_internal: "caseDeterminDate",
      to: "pwdDeterminationDate",
    },
    {
      from_internal: "empBusinessName",
      to: "empBusinessName",
    },
    {
      from_internal: "empTradeName",
      to: "empTradeName",
    },
    {
      from_internal: "empAddr1",
      to: "empAddr1",
    },
    {
      from_internal: "empAddr2",
      to: "empAddr2",
    },
    {
      from_internal: "empCity",
      to: "empCity",
    },
    {
      from_internal: "empState",
      to: "empState",
      type: "state",
    },
    {
      from_internal: "empPostcode",
      to: "empPostcode",
    },
    {
      from_internal: "empCountry",
      to: "empCountry",
    },
    {
      from_internal: "empProvince",
      to: "empProvince",
    },
    {
      from_internal: "empPhone",
      to: "empPhone",
    },
    {
      from_internal: "empPhoneext",
      to: "empPhoneext",
    },
    {
      from_internal: "empFein",
      to: "empFein",
    },
    {
      from_internal: "empNaics",
      to: "empNaics",
      type: "string",
    },
    {
      from_internal: "empNaicsDesc",
      to: "empNaicsDescription",
      type: "string",
    },
    {
      from_internal: "jobDuties",
      to: "jobDuties",
    },
    {
      from_internal: "primaryEducationLevel",
      to: "jobMinedu",
    },
    {
      from_internal: "specialRequirements",
      to: "jobMinspecialreq",
    },
    {
      from_internal: "numberOfMonthsTraining",
      to: "jobMintrainingmonths",
      type: "number",
    },
    {
      from_internal: "empExperienceMonths",
      to: "jobMinexpmonths",
      type: "number",
    },
    {
      from_internal: "superviseOtherEmp",
      to: "jobSupervisor",
      type: "bool",
    },
    {
      from_internal: "superviseHowMany",
      to: "jobNumberSup",
      type: "number",
    },
    {
      from_internal: "primaryWorksiteAddr1",
      to: "jobAddr1",
    },
    {
      from_internal: "primaryWorksiteAddr2",
      to: "jobAddr2",
    },
    {
      from_internal: "primaryWorksiteCity",
      to: "jobCity",
    },
    {
      from_internal: "primaryWorksiteState",
      to: "jobState",
    },
    {
      from_internal: "primaryWorksitePostalCode",
      to: "jobPostcode",
    },
    {
      from_internal: "primaryWorksiteCounty",
      to: "jobCounty",
    },
    {
      from_internal: "primaryWorksiteBlsArea",
      to: "jobMsa",
    },
    {
      from_internal: "caseNumber",
      to: "jobPwdNumber1",
    },
    {
      from_internal: "otherWorksiteLocation",
      to: "jobMultiplesites",
      type: "bool",
    },
    {
      from_internal: "otherWorksites",
      to: "employmentLocationWorksites",
    },
    {
      from_internal: "caseStatus",
      to: "_9141_meta_case_status",
    },
    {
      from_internal: "pwdWageRate",
      to: "_9141_f4_prevailing_wage",
      type: "wageNumToString",
    },
    {
      from_internal: "pwdUnitOfPay",
      to: "_9141_f5_wage_per",
    },
    {
      from_internal: "pwdUnitOfPay",
      to: "wagePer",
      type: "per",
    },
  ],
  9089: [
    {
      from_internal: "otherWorksites",
      to: "appx_b_worksites",
    },
    {
      from_internal: "_blsCounties",
      to: "_blsCounties",
      type: "string",
    },
    {
      from_internal: "empBusinessName",
      to: "empBusinessName",
    },
    {
      from_internal: "caseNumber",
      to: "jobOppPWDNumber",
    },
    {
      from_internal: "empTradeName",
      to: "empTradeName",
    },
    {
      from_internal: "empAddr1",
      to: "empAddr1",
    },
    {
      from_internal: "empAddr2",
      to: "empAddr2",
    },
    {
      from_internal: "empCity",
      to: "empCity",
    },
    {
      from_internal: "empState",
      to: "empState",
      type: "state",
    },
    {
      from_internal: "empPostcode",
      to: "empPostcode",
    },
    {
      from_internal: "empCountry",
      to: "empCountry",
    },
    {
      from_internal: "empProvince",
      to: "empProvince",
    },
    {
      from_internal: "empPhone",
      to: "empPhone",
    },
    {
      from_internal: "empPhoneext",
      to: "empPhoneext",
    },
    {
      from_internal: "empFein",
      to: "empFein",
    },
    {
      from_internal: "empNaics",
      to: "empNaics",
      type: "string",
    },
    {
      from_internal: "empNaicsDesc",
      to: "empNaicsDesc",
      type: "string",
    },
    {
      from_internal: "requestorPocLastName",
      to: "empPocLastName",
    },
    {
      from_internal: "requestorPocFirstName",
      to: "empPocFirstName",
    },
    {
      from_internal: "requestorPocMiddleName",
      to: "empPocMiddleName",
    },
    {
      from_internal: "requestorPocJobTitle",
      to: "empPocJobTitle",
    },
    {
      from_internal: "requestorPocAddr1",
      to: "empPocAddr1",
    },
    {
      from_internal: "requestorPocAddr2",
      to: "empPocAddr2",
    },
    {
      from_internal: "requestorPocCity",
      to: "empPocCity",
    },
    {
      from_internal: "requestorPocState",
      to: "empPocState",
      type: "state",
    },
    {
      from_internal: "requestorPocPostalCode",
      to: "empPocPostalCode",
    },
    {
      from_internal: "requestorPocCountry",
      to: "empPocCountry",
    },
    {
      from_internal: "requestorPocProvince",
      to: "empPocProvince",
    },
    {
      from_internal: "requestorPocPhone",
      to: "empPocPhone",
    },
    {
      from_internal: "requestorPocPhoneExt",
      to: "empPocPhoneExt",
    },
    {
      from_internal: "requestorPocEmail",
      to: "empPocEmail",
    },
    {
      from_internal: "attyRepresentType",
      to: "attyAgRepType",
    },
    {
      from_internal: "attyLastname",
      to: "attyAgLastName",
    },
    {
      from_internal: "attyFirstname",
      to: "attyAgFirstName",
    },
    {
      from_internal: "attyMiddlename",
      to: "attyAgMiddleName",
    },
    {
      from_internal: "attyAddr1",
      to: "attyAgAddress1",
    },
    {
      from_internal: "attyAddr2",
      to: "attyAgAddress2",
    },
    {
      from_internal: "attyCity",
      to: "attyAgCity",
    },
    {
      from_internal: "attyState",
      to: "attyAgState",
      type: "state",
    },
    {
      from_internal: "attyPostcode",
      to: "attyAgPostalCode",
    },
    {
      from_internal: "attyCountry",
      to: "attyAgCountry",
    },
    {
      from_internal: "attyProvince",
      to: "attyAgProvince",
    },
    {
      from_internal: "attyPhone",
      to: "attyAgPhone",
    },
    {
      from_internal: "attyPhoneext",
      to: "attyAgPhoneExt",
    },
    {
      from_internal: "attyEmail",
      to: "attyAgEmail",
    },
    {
      from_internal: "attyBizname",
      to: "attyAgLawFirmName",
    },
    {
      from_internal: "attyFein",
      to: "attyAgFEIN",
    },
    // This is only imported when no other worksites. Check pwPrefiller.js
    // {
    //   from_internal: "primaryWorksiteAddr1",
    //   to: "primaryWorksiteAddr1",
    //   optionalWorksiteInfo: true,
    // },
    // {
    //   from_internal: "primaryWorksiteAddr2",
    //   to: "primaryWorksiteAddr2",
    //   optionalWorksiteInfo: true,
    // },
    // {
    //   from_internal: "primaryWorksiteCity",
    //   to: "primaryWorksiteCity",
    //   optionalWorksiteInfo: true,
    // },
    // {
    //   from_internal: "primaryWorksiteCounty",
    //   to: "primaryWorksiteCounty",
    //   optionalWorksiteInfo: true,
    // },
    // {
    //   from_internal: "primaryWorksiteState",
    //   to: "primaryWorksiteState",
    //   optionalWorksiteInfo: true,
    // },
    // {
    //   from_internal: "primaryWorksitePostalCode",
    //   to: "primaryWorksitePostalCode",
    //   optionalWorksiteInfo: true,
    // },
    // {
    //   from_internal: "primaryWorksiteBlsArea",
    //   to: "primaryWorksiteBlsArea",
    //   optionalWorksiteInfo: true,
    // },
    {
      from_internal: "jobOppPWDAttached",
      to: "jobOppPWDAttached",
    },
    {
      from_internal: "pwdUnitOfPay",
      to: "pwdUnitOfPay",
    },
    {
      from_internal: "pwdWageRate",
      to: "pwdWageRate",
    },
    {
      from_internal: "_blsCounties",
      to: "_blsCounties",
    },
    {
      from_internal: "jobTitle",
      to: "jobTitle",
    },
  ],
};
